__turbopack_context__.v({
  "breadcrumbWrap": "SeasonalDeals-module__BpQS6G__breadcrumbWrap",
  "emptyState": "SeasonalDeals-module__BpQS6G__emptyState",
  "loadingWrap": "SeasonalDeals-module__BpQS6G__loadingWrap",
  "page": "SeasonalDeals-module__BpQS6G__page",
  "regionTab": "SeasonalDeals-module__BpQS6G__regionTab",
  "regionTabActive": "SeasonalDeals-module__BpQS6G__regionTabActive",
  "regionTabs": "SeasonalDeals-module__BpQS6G__regionTabs",
});
